import React from 'react';
export default function BulletItem(props){
    return(
        <div className="bullet_item_conatiner" id={props.id}>
            <div className="bullet_item_conatiner__bullet"></div>
            <div className="bullet_item_conatiner__text">
                <ul>
                    <li className="bullet_item_conatiner__text__title">{props.text}</li>
                </ul>
            </div>
        </div>
    );
}